/* 2024-04-01
 * This is a stripped down GeoLocator w/o the ability to draw or save a track.
 * The old version w/ tracking in is src/backup/
 * This version replaces cscs with proj4.
 */

import GeomPoint from '../node_modules/ol/geom/Point.js';
import GeomCircle from '../node_modules/ol/geom/Circle.js';
import Feature from '../node_modules/ol/Feature.js';
import LayerVector from '../node_modules/ol/layer/Vector.js';
import SourceVector from '../node_modules/ol/source/Vector.js';

import makeStyle from './makeStyle.js'

/**
 * @constructor
 */

export default function() {
  var       // private instance variables
    wpid,   // watch point id
    state = 'off',  // currently 3 states [on | off | working] but maybe more later e.g. recording
    lastp = {x:0, y:0},
    positionPoint = new GeomPoint([0,0]),
    accuracyCircle = new GeomCircle([0,0],0),
    extent = rwg.config.olView.extent,
    mapMetersPerUnit = rwg.map.getView().getProjection().getMetersPerUnit(),
    gpsColor = {
      on: '#A2F35D',
      off: '',
      working: 'orange'
    },
    accuracyFeature = new Feature({
      geometry: accuracyCircle
    }),
    positionFeature = new Feature({
      geometry: positionPoint
    });

  accuracyFeature.setStyle(makeStyle({  // setting style in constructor doesn't work
      fill: {color: [255, 255, 255, 0.2]},
      stroke: {color: 'pink'}
    }))
  positionFeature.setStyle(makeStyle({  // setting style in constructor doesn't work
    circle: {
      radius: 6,
      fill: {color: 'orange' },
      stroke: {color: '#fff'}
    }
  }))



  // private function
  function startTracking() {
    if (!('geolocation' in navigator)) {
      alert('geolocation is not available');
      return false;
    } else {
      wpid = navigator.geolocation.watchPosition(
        geo_success,
        geo_error,
        { enableHighAccuracy: true,
          maximumAge: 30000,
          timeout: 27000
        }
      );
      state = 'working';
      document.querySelectorAll('.icon-gps').forEach(function(i){
        i.style.color=gpsColor[state];
      });
    }
  }

  // private function
  function stopTracking() {
    navigator.geolocation.clearWatch(wpid);
    state = 'off';
    lastp.x = lastp.y = 0;
    document.querySelectorAll('.icon-gps').forEach(function(i){
      i.style.color=gpsColor[state];
    });
    positionPoint.setCoordinates([0,0]);
    accuracyCircle.setCenter([0,0]);
    accuracyCircle.setRadius(0);
  }

  // private function
  function geo_error(error) {
    var errorMsg;
    switch(error.code) {
    case error.PERMISSION_DENIED:
      errorMsg = 'Location permission denied.\nPlease allow "Location" in your settings.\n' + error.message;
      break;
    case error.POSITION_UNAVAILABLE:
      errorMsg = 'Location is unavailable.\n' + error.message;
      break;
    case error.TIMEOUT:
      errorMsg = 'Location timed out.\nTry turning WiFi off\n' + error.message;
      break;
      // case error.UNKNOWN_ERROR:
    default:
      errorMsg = 'Unknown Location error.\n' + error.message;
    }
    alert(errorMsg);
    stopTracking();
  }

  // private function
  function geo_success(position) {

    let p = rwg.proj.transform('EPSG:4326', rwg.proj.mapSRID, {x: position.coords.longitude, y: position.coords.latitude})

    if (p.x < extent[0] || p.x > extent[2] ||
        p.y < extent[1] || p.y > extent[3]) {
      alert('Sorry, but your reported location\n(lat: ' +
        Math.round(position.coords.latitude * 10000) / 10000 + ' lon: ' +
        Math.round(position.coords.longitude * 10000) / 10000 +
        ')\nis outside of the area covered by this map.');
      stopTracking();
      return;
    }


    // check that it moved enough to matter (more than resolution or more than accuracy or more than ???)
    // comparing to resolution is okay for display but if recording a track when user is zoomed out it
    // may still be desirable to save the point. Using some percentage of accuracy might be appropriate.
    let d = Math.hypot(p.x - lastp.x, p.y - lastp.y);

    if (d > rwg.map.getView().getResolution()) {
      // when lastp.x === 0 this is the very first position so see if we're zoomed out too far to see the position feature
      // would be nice to check if any features are selected and try to keep them in view also
      if (lastp.x === 0 && rwg.map.getView().getResolution() * mapMetersPerUnit > 5) {
        rwg.map.getView().setResolution(5 / mapMetersPerUnit)
      }
      let viewExtent = rwg.map.getView().calculateExtent(rwg.map.getSize());
      // don't recenter the map if position is within view
      if (p.x < viewExtent[0] || p.x > viewExtent[2] || p.y < viewExtent[1] || p.y > viewExtent[3]) {
        rwg.map.getView().setCenter([p.x, p.y]);
      }

      positionPoint.setCoordinates([p.x, p.y])
      accuracyCircle.setCenter([p.x, p.y])
      accuracyCircle.setRadius(position.coords.accuracy / mapMetersPerUnit)

      if (state === 'working') {
        state = 'on';
        document.querySelectorAll('.icon-gps').forEach(i => i.style.color=gpsColor[state])
      }
      lastp = p
    }
  }

  const olLayer = new LayerVector({
    title: 'lyrGeoLocation',
    source: new SourceVector({
      features: [accuracyFeature, positionFeature]
    }),
    zIndex: 10,
  });

  // toggle tracking on/off
  const toggle = function() {
    if (state === 'off') {
      startTracking()
    } else if (state === 'on' || state === 'working') {
      stopTracking()
    }
  }

  return {
    olLayer: olLayer,
    toggle: toggle
  }
};
